'use strict';

import Vue from 'vue';
import Globalize from 'globalize';
import moment from 'moment';

//https://github.com/globalizejs/globalize/blob/master/doc/api/date/date-formatter.md

const dateFilter = function(value, format) {
  try 
  {
    if(value == null || value == '') return value;

    return Globalize.dateFormatter({ date: format || 'short'})(new Date(value));
  } 
  catch (e) 
  {
    return value;
  }
};

//https://momentjs.com/guides/
const formatDateTimeFilter = function(value, format) {
  try 
  {
    if(value == null || value == '') return value;

    return moment(new Date(value)).format(format);
  }
  catch (e) {
    return value;
  }
};

const timeFilter = function(value, format) {
  try 
  {
    if(value == null || value == '') return value;
    
    return Globalize.dateFormatter({ time: format || "short" })(new Date(value));
  }
  catch (e) 
  {
    return value;
  }
};

const datetimeFilter = function(value, format) {
  try 
  {
    if(value == null || value == '') return value;

    return Globalize.dateFormatter({ datetime: format || 'short'})(new Date(value));
  } 
  catch (e) 
  {
    return value;
  }
};

const numberFilter = function(value, options) {
  try {
    return Globalize.formatNumber(value, options || {});
  } catch (e) {
    return value;
  }
};

const percentFilter = function(value, options) {
  try {
    options = options || {};
    options.style = options.style || 'percent';
    return Globalize.formatNumber(value, options);
  } catch (e) {
    return value;
  }
};
const pluralFilter = function(value, type) {
  try {
    return Globalize.plural(value, {type: type || 'cardinal'});
  } catch (e) {
    return value;
  }
};

const relativeTimeFilter = function(value, unit, options) {
  try {
    return Globalize.formatRelativeTime(unit, options || {})(value);
  } catch (e) {
    return value;
  }
};

const unitFilter = function(value, unit, options) {
  try {
    return Globalize.formatUnit(unit, options || {})(value);
  } catch (e) {
    return value;
  }
};

const centToFullFilter = function(value) {
  return (parseInt(value.toString()) / 100).toFixed(2);
};

const fullToCentFilter = function(value) {
  // Workaround vanwege getallen achter de komma als we met 100 vermenigvuldigen.
  // Voorbeelden: 9,95 omzetten naar centen => 9,95 * 100 => 994,9999999999 
  //              9,28 omzetten naar centen => 9,28 * 100 => 927,9999999999
  return parseInt(Math.round(parseFloat(value.toString()) * 100, 2));
};

const currencyFilter = function(value, currency = 'EUR', options = {}) {
  return Globalize.formatCurrency(value / 100, currency, options);
};

const cycleFilter = function(value) {
    let cycle = ''

    switch (value) {
        case 1:
            cycle = 'Maand'
            break;
        case 3:
            cycle = 'Kwartaal'
            break;
        case 12:
            cycle = 'Jaar'
            break;
    
        default:
            cycle = ''
            break;
    }
    return cycle;
};

const agreementTypeFilter = function(value) {
    let type = ''

    switch (value) {
        case 1:
            type = 'Licentie'
            break;
        case 2:
            type = 'Onderhoud'
            break;
    
        default:
            type = ''
            break;
    }
    return type;
};

const invoiceTypeFilter = function(value) {
    let type = ''

    switch (value) {
        case 1:
            type = 'Bijlage'
            break;
        case 2:
            type = 'Document'
            break;
        case 3:
            type = 'Factuur'
            break;
    
        default:
            type = ''
            break;
    }
    return type;
};

Vue.filter('date', dateFilter);
Vue.filter('formatDateTime',formatDateTimeFilter);
Vue.filter('time', timeFilter);
Vue.filter('datetime', datetimeFilter);
Vue.filter('number', numberFilter);
Vue.filter('percent', percentFilter);
Vue.filter('currency', currencyFilter);
Vue.filter('plural', pluralFilter);
Vue.filter('relativeTime', relativeTimeFilter);
Vue.filter('unit', unitFilter);
Vue.filter('centToFull', centToFullFilter);
Vue.filter('fullToCent', fullToCentFilter);
Vue.filter('cycle', cycleFilter);
Vue.filter('agreementType', agreementTypeFilter);
Vue.filter('invoiceType', invoiceTypeFilter);
Vue.prototype.format = {
  date: dateFilter,
  formatDate: formatDateTimeFilter,
  time: timeFilter,
  datetime: datetimeFilter,
  number: numberFilter,
  percent: percentFilter,
  currency: currencyFilter,
  plural: pluralFilter,
  relativeTime: relativeTimeFilter,
  unit: unitFilter,
  centToFull: centToFullFilter,
  fullToCent: fullToCentFilter,
  cycle: cycleFilter,
  agreementType: agreementTypeFilter,
  invoiceType: invoiceTypeFilter
};
